module.exports = __webpack_public_path__ + "static/media/password.03098c33.svg";